import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { whatsappUrl } from '../content/siteContent';
import Brand from './Brand';

const { FiMenu, FiX, FiArrowUpRight } = FiIcons;

const links = [
  ['Inicio', '#inicio'],
  ['Servicios', '#servicios'],
  ['Cómo funciona', '#como-funciona'],
  ['Cobertura', '#cobertura'],
  ['Para negocios', '#negocios'],
  ['Contacto', '#contacto']
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const updateHeader = () => setScrolled(window.scrollY > 24);

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    return () => window.removeEventListener('scroll', updateHeader);
  }, []);

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="container header__inner">
        <Brand compact />

        <button
          className="menu-button"
          type="button"
          onClick={() => setMenuOpen((value) => !value)}
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
        >
          <SafeIcon icon={menuOpen ? FiX : FiMenu} />
        </button>

        <nav
          className={`nav ${menuOpen ? 'nav--open' : ''}`}
          aria-label="Navegación principal"
        >
          {links.map(([label, href]) => (
            <a href={href} key={href} onClick={() => setMenuOpen(false)}>
              {label}
            </a>
          ))}

          <a
            className="button button--small"
            href={whatsappUrl()}
            target="_blank"
            rel="noreferrer"
          >
            Pedir un mandao
            <SafeIcon icon={FiArrowUpRight} />
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;